//@ts-ignore no types
import { actions } from '@adc/ui-morpheus'
import { fetchNotifications } from '../providers/communications'
import { COMMUNICATIONS } from '../constants/tableTypes'
import { UPDATE_COMMUNICATIONS } from '../constants/actionTypes'

export const updateCommunications = (communications: unknown[]) => ({
  type: UPDATE_COMMUNICATIONS,
  communications,
})

export const { fetchTable } = actions.dataTable.initDataTable(COMMUNICATIONS, {
  getTableValues: fetchNotifications,
})
